module.exports = __webpack_public_path__ + "img/search-glass.a4125a99.svg";